export { jobTypesEn } from './en';
export { jobTypesSk } from './sk';
export { jobTypesCz } from './cz';

// Helper function to get job types by language
import { jobTypesEn } from './en';
import { jobTypesSk } from './sk';
import { jobTypesCz } from './cz';

export function getJobTypes(lang: 'sk' | 'en' | 'cz') {
  switch (lang) {
    case 'sk':
      return jobTypesSk;
    case 'en':
      return jobTypesEn;
    case 'cz':
      return jobTypesCz;
    default:
      return jobTypesSk; // fallback to Slovak
  }
}